import React from 'react'

import { Form, Col } from '_zari/core'

const MesFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='MES' htmlFor='select-mes' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.Select id='select-mes' name='select-mes' value={value} onChange={onChange}>
          <option value=''>--</option>
          <option value='01'>Enero</option>
          <option value='02'>Febrero</option>
          <option value='03'>Marzo</option>
          <option value='04'>Abril</option>
          <option value='05'>Mayo</option>
          <option value='06'>Junio</option>
          <option value='07'>Julio</option>
          <option value='08'>Agosto</option>
          <option value='09'>Septiembre</option>
          <option value='10'>Octubre</option>
          <option value='11'>Noviembre</option>
          <option value='12'>Diciembre</option>
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesFormGroup)
